import React, { PureComponent } from 'react'
import { Collapse, Table } from 'react-bootstrap'
import AMLSourceListItem from './aml_source_list_items'
// this file is for the Minerva AML Sources
class AMLSources extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      open: true,
      hits: [],
      sourceTypes: [],
    }
  }

  componentDidMount() {
    const { props } = this
    const { identityDataSources, updateComplianceCount, sourceTypes } = props
    if (identityDataSources && identityDataSources[0]) {
      const amlHits = identityDataSources[0].aml_hits

      let hits = amlHits.map((h) => {
        const data = h.aml_sources || []
        return { ...h, dataListings: data }
      })

      this.setState({ sourceTypes })
      hits = hits.filter((hit) => {
        const listing = hit.dataListings.map((d) => d.source_type).join(' ')
        return listing.includes('Sanctions')
      })
      hits = this.getHits(hits)
      updateComplianceCount(hits.filter((h) => !h.checked).length)
      this.setState({ hits })
    }
  }

  confirm = (hit) => (event) => {
    if (event.target.checked) {
      window.localStorage.setItem(`${this.props.id}-sanction-${hit.id}`, 'checked')
      const count = this.props.count - 1
      this.props.updateComplianceCount(count < 0 ? 0 : count)
    } else {
      window.localStorage.removeItem(`${this.props.id}-sanction-${hit.id}`)
      this.props.updateComplianceCount(this.props.count + 1)
    }
  }

  getHits = (origArray) => {
    const { props } = this
    return origArray.reduce((filtered, hit) => {
      const checkboxState = window.localStorage.getItem(`${props.id}-sanction-${hit.id}`)
      filtered.push({
        ...hit,
        checked: checkboxState === 'checked',
      })
      return filtered
    }, [])
  }

  render() {
    const { props, state } = this
    const { data } = props

    const { hits, sourceTypes } = state
    const chevronClass = state.open ? 'fa fa-chevron-down' : 'fa fa-chevron-right'
    let alertClass = 'label label-info-danger'
    if (data && data.length) {
      alertClass = 'label label-info-data-danger'
    }
    const borderRadius = state.open ? '10px 10px 0 0' : '10px 10px 10px 10px'
    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <div
          style={{ borderRadius: borderRadius, cursor: 'pointer' }}
          onClick={() => this.setState({ open: !state.open, viewedNew: true })}
          className='ibox-title'
        >
          <i style={{ width: '10px' }} className={chevronClass} />
          <header>
            {sourceTypes.includes('Sanctions')
              ? 'Global Sanctions Matches & Global Watchlist Matches'
              : 'PEP and Adverse Media Matches'}
          </header>
          <span style={{ float: 'right' }} className={alertClass}>
            {hits.length}
          </span>
        </div>
        <Collapse in={state.open}>
          <div>
            <div style={{ borderRadius: '0 0 10px 10px' }} className='ibox-content table-responsive'>
              {hits.length ? (
                <Table bordered hover>
                  <thead>
                    <tr>
                      <th>Results by Name</th>
                      <th>Reviewed by Compliance</th>
                    </tr>
                  </thead>
                  <tbody>
                    {hits.map((hit, i) => (
                      <AMLSourceListItem
                        key={i}
                        checked={hit.checked}
                        collapseSection={this.collapseSection}
                        confirm={this.confirm(hit)}
                        hit={hit}
                        sourceTypes={sourceTypes}
                      />
                    ))}
                  </tbody>
                </Table>
              ) : (
                <span>{'N/A'}</span>
              )}
            </div>
          </div>
        </Collapse>
      </div>
    )
  }
}

export default AMLSources
